module.exports = __webpack_public_path__ + "static/img/6.27a38f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/6.png
// module id = DkQy
// module chunks = 0